import type { PostLikerUserFields as Liker } from '../../../generated/graphql';

export const isLiker = (input: any): input is Liker => {
  const isObject = typeof input === 'object' && !!input && !Array.isArray(input);
  const hasAllRequiredProperties = ['_id', 'avatar', 'firstName', 'lastName', 'nickname'].every(
    property => Object.keys(input).includes(property),
  );

  return isObject && hasAllRequiredProperties;
};
